function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "mapwrap_svg__bg-layer",
  vectorEffect: "non-scaling-stroke",
  d: "M1883.998 4.09H807.576L479.564 35.696 253.886 91.222 124.928 247.888l-52.39 160.63-36.27 380.756-18.134 323.244L1.542 1408H0V0h1883.998v4.09z",
  fill: "#fff",
  fillRule: "nonzero"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M1883.998 4.09H807.576L479.564 35.696 253.886 91.222 124.928 247.888l-52.39 160.63-36.27 380.756-18.134 323.244L1.542 1408",
  fill: "none",
  stroke: "currentColor"
});

function SvgMapwrap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1884 1408",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTg4NCAxNDA4IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2UtbWl0ZXJsaW1pdD0iMiI+CiAgPHBhdGggY2xhc3M9ImJnLWxheWVyIiB2ZWN0b3ItZWZmZWN0PSJub24tc2NhbGluZy1zdHJva2UiIGQ9Ik0xODgzLjk5OCA0LjA5SDgwNy41NzZMNDc5LjU2NCAzNS42OTYgMjUzLjg4NiA5MS4yMjIgMTI0LjkyOCAyNDcuODg4bC01Mi4zOSAxNjAuNjMtMzYuMjcgMzgwLjc1Ni0xOC4xMzQgMzIzLjI0NEwxLjU0MiAxNDA4SDBWMGgxODgzLjk5OHY0LjA5eiIgZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJub256ZXJvIi8+CiAgPHBhdGggdmVjdG9yLWVmZmVjdD0ibm9uLXNjYWxpbmctc3Ryb2tlIiBkPSJNMTg4My45OTggNC4wOUg4MDcuNTc2TDQ3OS41NjQgMzUuNjk2IDI1My44ODYgOTEuMjIyIDEyNC45MjggMjQ3Ljg4OGwtNTIuMzkgMTYwLjYzLTM2LjI3IDM4MC43NTYtMTguMTM0IDMyMy4yNDRMMS41NDIgMTQwOCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMSIvPgo8L3N2Zz4=";
export { SvgMapwrap as ReactComponent };